/**
 * Do not edit directly
 * Generated on Wed, 19 Oct 2022 04:48:52 GMT
 */

module.exports = {
  "color": {
    "ubie-black-100": {
      "value": "#16191f",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#16191f0a"
      },
      "name": "ColorUbieBlack100",
      "attributes": {
        "category": "color",
        "type": "ubie-black-100"
      },
      "path": [
        "color",
        "ubie-black-100"
      ]
    },
    "ubie-black-200": {
      "value": "#16191f",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#16191f2e"
      },
      "name": "ColorUbieBlack200",
      "attributes": {
        "category": "color",
        "type": "ubie-black-200"
      },
      "path": [
        "color",
        "ubie-black-200"
      ]
    },
    "ubie-black-400": {
      "value": "#16191f",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#16191f7a"
      },
      "name": "ColorUbieBlack400",
      "attributes": {
        "category": "color",
        "type": "ubie-black-400"
      },
      "path": [
        "color",
        "ubie-black-400"
      ]
    },
    "ubie-black-500": {
      "value": "#16191f",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#16191fa3"
      },
      "name": "ColorUbieBlack500",
      "attributes": {
        "category": "color",
        "type": "ubie-black-500"
      },
      "path": [
        "color",
        "ubie-black-500"
      ]
    },
    "ubie-black-700": {
      "value": "#16191f",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#16191fe5"
      },
      "name": "ColorUbieBlack700",
      "attributes": {
        "category": "color",
        "type": "ubie-black-700"
      },
      "path": [
        "color",
        "ubie-black-700"
      ]
    },
    "ubie-black-900": {
      "value": "#16191f",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#16191f"
      },
      "name": "ColorUbieBlack900",
      "attributes": {
        "category": "color",
        "type": "ubie-black-900"
      },
      "path": [
        "color",
        "ubie-black-900"
      ]
    },
    "ubie-blue-100": {
      "value": "#f2f6fd",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#f2f6fd"
      },
      "name": "ColorUbieBlue100",
      "attributes": {
        "category": "color",
        "type": "ubie-blue-100"
      },
      "path": [
        "color",
        "ubie-blue-100"
      ]
    },
    "ubie-blue-200": {
      "value": "#cbd3f2",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#cbd3f2"
      },
      "name": "ColorUbieBlue200",
      "attributes": {
        "category": "color",
        "type": "ubie-blue-200"
      },
      "path": [
        "color",
        "ubie-blue-200"
      ]
    },
    "ubie-blue-400": {
      "value": "#6a82d9",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#6a82d9"
      },
      "name": "ColorUbieBlue400",
      "attributes": {
        "category": "color",
        "type": "ubie-blue-400"
      },
      "path": [
        "color",
        "ubie-blue-400"
      ]
    },
    "ubie-blue-500": {
      "value": "#3959cc",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#3959cc"
      },
      "name": "ColorUbieBlue500",
      "attributes": {
        "category": "color",
        "type": "ubie-blue-500"
      },
      "path": [
        "color",
        "ubie-blue-500"
      ]
    },
    "ubie-blue-700": {
      "value": "#263f94",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#263f94"
      },
      "name": "ColorUbieBlue700",
      "attributes": {
        "category": "color",
        "type": "ubie-blue-700"
      },
      "path": [
        "color",
        "ubie-blue-700"
      ]
    },
    "ubie-pink-100": {
      "value": "#fdf2f9",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#fdf2f9"
      },
      "name": "ColorUbiePink100",
      "attributes": {
        "category": "color",
        "type": "ubie-pink-100"
      },
      "path": [
        "color",
        "ubie-pink-100"
      ]
    },
    "ubie-pink-200": {
      "value": "#f8cfde",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#f8cfde"
      },
      "name": "ColorUbiePink200",
      "attributes": {
        "category": "color",
        "type": "ubie-pink-200"
      },
      "path": [
        "color",
        "ubie-pink-200"
      ]
    },
    "ubie-pink-400": {
      "value": "#ea77a1",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#ea77a1"
      },
      "name": "ColorUbiePink400",
      "attributes": {
        "category": "color",
        "type": "ubie-pink-400"
      },
      "path": [
        "color",
        "ubie-pink-400"
      ]
    },
    "ubie-pink-500": {
      "value": "#da3170",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#da3170"
      },
      "name": "ColorUbiePink500",
      "attributes": {
        "category": "color",
        "type": "ubie-pink-500"
      },
      "path": [
        "color",
        "ubie-pink-500"
      ]
    },
    "ubie-pink-700": {
      "value": "#a33961",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#a33961"
      },
      "name": "ColorUbiePink700",
      "attributes": {
        "category": "color",
        "type": "ubie-pink-700"
      },
      "path": [
        "color",
        "ubie-pink-700"
      ]
    },
    "ubie-red-100": {
      "value": "#fcf4f4",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#fcf4f4"
      },
      "name": "ColorUbieRed100",
      "attributes": {
        "category": "color",
        "type": "ubie-red-100"
      },
      "path": [
        "color",
        "ubie-red-100"
      ]
    },
    "ubie-red-200": {
      "value": "#f6d0d0",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#f6d0d0"
      },
      "name": "ColorUbieRed200",
      "attributes": {
        "category": "color",
        "type": "ubie-red-200"
      },
      "path": [
        "color",
        "ubie-red-200"
      ]
    },
    "ubie-red-400": {
      "value": "#ec6d6d",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#ec6d6d"
      },
      "name": "ColorUbieRed400",
      "attributes": {
        "category": "color",
        "type": "ubie-red-400"
      },
      "path": [
        "color",
        "ubie-red-400"
      ]
    },
    "ubie-red-500": {
      "value": "#db3939",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#db3939"
      },
      "name": "ColorUbieRed500",
      "attributes": {
        "category": "color",
        "type": "ubie-red-500"
      },
      "path": [
        "color",
        "ubie-red-500"
      ]
    },
    "ubie-red-700": {
      "value": "#b02b2b",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#b02b2b"
      },
      "name": "ColorUbieRed700",
      "attributes": {
        "category": "color",
        "type": "ubie-red-700"
      },
      "path": [
        "color",
        "ubie-red-700"
      ]
    },
    "ubie-white": {
      "value": "#ffffff",
      "filePath": "tokens/color/primitive.json",
      "isSource": true,
      "original": {
        "value": "#ffffff"
      },
      "name": "ColorUbieWhite",
      "attributes": {
        "category": "color",
        "type": "ubie-white"
      },
      "path": [
        "color",
        "ubie-white"
      ]
    },
    "accent": {
      "value": "#da3170",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-pink-500.value}"
      },
      "name": "ColorAccent",
      "attributes": {
        "category": "color",
        "type": "accent"
      },
      "path": [
        "color",
        "accent"
      ]
    },
    "accent-darken": {
      "value": "#a33961",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-pink-700.value}"
      },
      "name": "ColorAccentDarken",
      "attributes": {
        "category": "color",
        "type": "accent-darken"
      },
      "path": [
        "color",
        "accent-darken"
      ]
    },
    "alert": {
      "value": "#db3939",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-red-500.value}"
      },
      "name": "ColorAlert",
      "attributes": {
        "category": "color",
        "type": "alert"
      },
      "path": [
        "color",
        "alert"
      ]
    },
    "alert-darken": {
      "value": "#b02b2b",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-red-700.value}"
      },
      "name": "ColorAlertDarken",
      "attributes": {
        "category": "color",
        "type": "alert-darken"
      },
      "path": [
        "color",
        "alert-darken"
      ]
    },
    "background-accent": {
      "value": "#fdf2f9",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-pink-100.value}"
      },
      "name": "ColorBackgroundAccent",
      "attributes": {
        "category": "color",
        "type": "background-accent"
      },
      "path": [
        "color",
        "background-accent"
      ]
    },
    "background-accent-darken": {
      "value": "#f8cfde",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-pink-200.value}"
      },
      "name": "ColorBackgroundAccentDarken",
      "attributes": {
        "category": "color",
        "type": "background-accent-darken"
      },
      "path": [
        "color",
        "background-accent-darken"
      ]
    },
    "background-alert": {
      "value": "#fcf4f4",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-red-100.value}"
      },
      "name": "ColorBackgroundAlert",
      "attributes": {
        "category": "color",
        "type": "background-alert"
      },
      "path": [
        "color",
        "background-alert"
      ]
    },
    "background-gray": {
      "value": "#16191f",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-black-100.value}"
      },
      "name": "ColorBackgroundGray",
      "attributes": {
        "category": "color",
        "type": "background-gray"
      },
      "path": [
        "color",
        "background-gray"
      ]
    },
    "background-modal": {
      "value": "#000000",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "#00000080"
      },
      "name": "ColorBackgroundModal",
      "attributes": {
        "category": "color",
        "type": "background-modal"
      },
      "path": [
        "color",
        "background-modal"
      ]
    },
    "background-primary": {
      "value": "#f2f6fd",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-blue-100.value}"
      },
      "name": "ColorBackgroundPrimary",
      "attributes": {
        "category": "color",
        "type": "background-primary"
      },
      "path": [
        "color",
        "background-primary"
      ]
    },
    "background-primary-darken": {
      "value": "#cbd3f2",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-blue-200.value}"
      },
      "name": "ColorBackgroundPrimaryDarken",
      "attributes": {
        "category": "color",
        "type": "background-primary-darken"
      },
      "path": [
        "color",
        "background-primary-darken"
      ]
    },
    "background-white": {
      "value": "#ffffff",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-white.value}"
      },
      "name": "ColorBackgroundWhite",
      "attributes": {
        "category": "color",
        "type": "background-white"
      },
      "path": [
        "color",
        "background-white"
      ]
    },
    "border": {
      "value": "#16191f",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-black-200.value}"
      },
      "name": "ColorBorder",
      "attributes": {
        "category": "color",
        "type": "border"
      },
      "path": [
        "color",
        "border"
      ]
    },
    "overlay": {
      "value": "#000000",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "#00000033"
      },
      "name": "ColorOverlay",
      "attributes": {
        "category": "color",
        "type": "overlay"
      },
      "path": [
        "color",
        "overlay"
      ]
    },
    "primary": {
      "value": "#3959cc",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-blue-500.value}"
      },
      "name": "ColorPrimary",
      "attributes": {
        "category": "color",
        "type": "primary"
      },
      "path": [
        "color",
        "primary"
      ]
    },
    "primary-darken": {
      "value": "#263f94",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-blue-700.value}"
      },
      "name": "ColorPrimaryDarken",
      "attributes": {
        "category": "color",
        "type": "primary-darken"
      },
      "path": [
        "color",
        "primary-darken"
      ]
    },
    "text-disabled": {
      "value": "#16191f",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-black-200.value}"
      },
      "name": "ColorTextDisabled",
      "attributes": {
        "category": "color",
        "type": "text-disabled"
      },
      "path": [
        "color",
        "text-disabled"
      ]
    },
    "text-link": {
      "value": "#3959cc",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-blue-500.value}"
      },
      "name": "ColorTextLink",
      "attributes": {
        "category": "color",
        "type": "text-link"
      },
      "path": [
        "color",
        "text-link"
      ]
    },
    "text-link-sub": {
      "value": "#16191f",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-black-500.value}"
      },
      "name": "ColorTextLinkSub",
      "attributes": {
        "category": "color",
        "type": "text-link-sub"
      },
      "path": [
        "color",
        "text-link-sub"
      ]
    },
    "text-main": {
      "value": "#16191f",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-black-700.value}"
      },
      "name": "ColorTextMain",
      "attributes": {
        "category": "color",
        "type": "text-main"
      },
      "path": [
        "color",
        "text-main"
      ]
    },
    "text-placeholder": {
      "value": "#16191f",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-black-400.value}"
      },
      "name": "ColorTextPlaceholder",
      "attributes": {
        "category": "color",
        "type": "text-placeholder"
      },
      "path": [
        "color",
        "text-placeholder"
      ]
    },
    "text-sub": {
      "value": "#16191f",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-black-500.value}"
      },
      "name": "ColorTextSub",
      "attributes": {
        "category": "color",
        "type": "text-sub"
      },
      "path": [
        "color",
        "text-sub"
      ]
    },
    "text-white": {
      "value": "#ffffff",
      "filePath": "tokens/color/semantics.json",
      "isSource": true,
      "original": {
        "value": "{color.ubie-white.value}"
      },
      "name": "ColorTextWhite",
      "attributes": {
        "category": "color",
        "type": "text-white"
      },
      "path": [
        "color",
        "text-white"
      ]
    }
  },
  "radius": {
    "md": {
      "value": "8px",
      "filePath": "tokens/size/radius.json",
      "isSource": true,
      "original": {
        "value": "8px"
      },
      "name": "RadiusMd",
      "attributes": {
        "category": "radius",
        "type": "md"
      },
      "path": [
        "radius",
        "md"
      ]
    },
    "full": {
      "value": "9999px",
      "filePath": "tokens/size/radius.json",
      "isSource": true,
      "original": {
        "value": "9999px"
      },
      "name": "RadiusFull",
      "attributes": {
        "category": "radius",
        "type": "full"
      },
      "path": [
        "radius",
        "full"
      ]
    },
    "sm": {
      "value": "4px",
      "filePath": "tokens/size/radius.json",
      "isSource": true,
      "original": {
        "value": "4px"
      },
      "name": "RadiusSm",
      "attributes": {
        "category": "radius",
        "type": "sm"
      },
      "path": [
        "radius",
        "sm"
      ]
    },
    "lg": {
      "value": "12px",
      "filePath": "tokens/size/radius.json",
      "isSource": true,
      "original": {
        "value": "12px"
      },
      "name": "RadiusLg",
      "attributes": {
        "category": "radius",
        "type": "lg"
      },
      "path": [
        "radius",
        "lg"
      ]
    },
    "xs": {
      "value": "2px",
      "filePath": "tokens/size/radius.json",
      "isSource": true,
      "original": {
        "value": "2px"
      },
      "name": "RadiusXs",
      "attributes": {
        "category": "radius",
        "type": "xs"
      },
      "path": [
        "radius",
        "xs"
      ]
    }
  },
  "size": {
    "spacing-xxl": {
      "value": "4rem",
      "attributes": {
        "note": "64px",
        "category": "size",
        "type": "spacing-xxl"
      },
      "filePath": "tokens/size/spacing.json",
      "isSource": true,
      "original": {
        "value": 4,
        "attributes": {
          "note": "64px"
        }
      },
      "name": "SizeSpacingXxl",
      "path": [
        "size",
        "spacing-xxl"
      ]
    },
    "spacing-xs": {
      "value": "0.5rem",
      "attributes": {
        "note": "8px",
        "category": "size",
        "type": "spacing-xs"
      },
      "filePath": "tokens/size/spacing.json",
      "isSource": true,
      "original": {
        "value": 0.5,
        "attributes": {
          "note": "8px"
        }
      },
      "name": "SizeSpacingXs",
      "path": [
        "size",
        "spacing-xs"
      ]
    },
    "spacing-xxs": {
      "value": "0.25rem",
      "attributes": {
        "note": "4px",
        "category": "size",
        "type": "spacing-xxs"
      },
      "filePath": "tokens/size/spacing.json",
      "isSource": true,
      "original": {
        "value": 0.25,
        "attributes": {
          "note": "4px"
        }
      },
      "name": "SizeSpacingXxs",
      "path": [
        "size",
        "spacing-xxs"
      ]
    },
    "spacing-md": {
      "value": "1rem",
      "attributes": {
        "note": "16px",
        "category": "size",
        "type": "spacing-md"
      },
      "filePath": "tokens/size/spacing.json",
      "isSource": true,
      "original": {
        "value": 1,
        "attributes": {
          "note": "16px"
        }
      },
      "name": "SizeSpacingMd",
      "path": [
        "size",
        "spacing-md"
      ]
    },
    "spacing-lg": {
      "value": "1.5rem",
      "attributes": {
        "note": "24px",
        "category": "size",
        "type": "spacing-lg"
      },
      "filePath": "tokens/size/spacing.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "24px"
        }
      },
      "name": "SizeSpacingLg",
      "path": [
        "size",
        "spacing-lg"
      ]
    },
    "spacing-xl": {
      "value": "2.5rem",
      "attributes": {
        "note": "40px",
        "category": "size",
        "type": "spacing-xl"
      },
      "filePath": "tokens/size/spacing.json",
      "isSource": true,
      "original": {
        "value": 2.5,
        "attributes": {
          "note": "40px"
        }
      },
      "name": "SizeSpacingXl",
      "path": [
        "size",
        "spacing-xl"
      ]
    },
    "spacing-sm": {
      "value": "0.75rem",
      "attributes": {
        "note": "12px",
        "category": "size",
        "type": "spacing-sm"
      },
      "filePath": "tokens/size/spacing.json",
      "isSource": true,
      "original": {
        "value": 0.75,
        "attributes": {
          "note": "12px"
        }
      },
      "name": "SizeSpacingSm",
      "path": [
        "size",
        "spacing-sm"
      ]
    }
  },
  "text": {
    "body-lg-size": {
      "value": "1.125rem",
      "attributes": {
        "note": "18px",
        "category": "text",
        "type": "body-lg-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1.125rem",
        "attributes": {
          "note": "18px"
        }
      },
      "name": "TextBodyLgSize",
      "path": [
        "text",
        "body-lg-size"
      ]
    },
    "body-lg-line": {
      "value": 1.7,
      "attributes": {
        "note": "170%",
        "category": "text",
        "type": "body-lg-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.7,
        "attributes": {
          "note": "170%"
        }
      },
      "name": "TextBodyLgLine",
      "path": [
        "text",
        "body-lg-line"
      ]
    },
    "body-lg-narrow-size": {
      "value": "1.125rem",
      "attributes": {
        "note": "18px",
        "category": "text",
        "type": "body-lg-narrow-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1.125rem",
        "attributes": {
          "note": "18px"
        }
      },
      "name": "TextBodyLgNarrowSize",
      "path": [
        "text",
        "body-lg-narrow-size"
      ]
    },
    "body-lg-narrow-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "body-lg-narrow-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextBodyLgNarrowLine",
      "path": [
        "text",
        "body-lg-narrow-line"
      ]
    },
    "body-lg-tight-size": {
      "value": "1.125rem",
      "attributes": {
        "note": "18px",
        "category": "text",
        "type": "body-lg-tight-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1.125rem",
        "attributes": {
          "note": "18px"
        }
      },
      "name": "TextBodyLgTightSize",
      "path": [
        "text",
        "body-lg-tight-size"
      ]
    },
    "body-lg-tight-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "body-lg-tight-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextBodyLgTightLine",
      "path": [
        "text",
        "body-lg-tight-line"
      ]
    },
    "body-md-size": {
      "value": "1rem",
      "attributes": {
        "note": "16px",
        "category": "text",
        "type": "body-md-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "attributes": {
          "note": "16px"
        }
      },
      "name": "TextBodyMdSize",
      "path": [
        "text",
        "body-md-size"
      ]
    },
    "body-md-line": {
      "value": 1.7,
      "attributes": {
        "note": "170%",
        "category": "text",
        "type": "body-md-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.7,
        "attributes": {
          "note": "170%"
        }
      },
      "name": "TextBodyMdLine",
      "path": [
        "text",
        "body-md-line"
      ]
    },
    "body-md-narrow-size": {
      "value": "1rem",
      "attributes": {
        "note": "16px",
        "category": "text",
        "type": "body-md-narrow-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "attributes": {
          "note": "16px"
        }
      },
      "name": "TextBodyMdNarrowSize",
      "path": [
        "text",
        "body-md-narrow-size"
      ]
    },
    "body-md-narrow-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "body-md-narrow-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextBodyMdNarrowLine",
      "path": [
        "text",
        "body-md-narrow-line"
      ]
    },
    "body-md-tight-size": {
      "value": "1rem",
      "attributes": {
        "note": "16px",
        "category": "text",
        "type": "body-md-tight-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "attributes": {
          "note": "16px"
        }
      },
      "name": "TextBodyMdTightSize",
      "path": [
        "text",
        "body-md-tight-size"
      ]
    },
    "body-md-tight-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "body-md-tight-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextBodyMdTightLine",
      "path": [
        "text",
        "body-md-tight-line"
      ]
    },
    "body-sm-size": {
      "value": "0.875rem",
      "attributes": {
        "note": "14px",
        "category": "text",
        "type": "body-sm-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.875rem",
        "attributes": {
          "note": "14px"
        }
      },
      "name": "TextBodySmSize",
      "path": [
        "text",
        "body-sm-size"
      ]
    },
    "body-sm-line": {
      "value": 1.7,
      "attributes": {
        "note": "170%",
        "category": "text",
        "type": "body-sm-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.7,
        "attributes": {
          "note": "170%"
        }
      },
      "name": "TextBodySmLine",
      "path": [
        "text",
        "body-sm-line"
      ]
    },
    "body-sm-narrow-size": {
      "value": "0.875rem",
      "attributes": {
        "note": "14px",
        "category": "text",
        "type": "body-sm-narrow-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.875rem",
        "attributes": {
          "note": "14px"
        }
      },
      "name": "TextBodySmNarrowSize",
      "path": [
        "text",
        "body-sm-narrow-size"
      ]
    },
    "body-sm-narrow-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "body-sm-narrow-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextBodySmNarrowLine",
      "path": [
        "text",
        "body-sm-narrow-line"
      ]
    },
    "body-sm-tight-size": {
      "value": "0.875rem",
      "attributes": {
        "note": "14px",
        "category": "text",
        "type": "body-sm-tight-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.875rem",
        "attributes": {
          "note": "14px"
        }
      },
      "name": "TextBodySmTightSize",
      "path": [
        "text",
        "body-sm-tight-size"
      ]
    },
    "body-sm-tight-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "body-sm-tight-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextBodySmTightLine",
      "path": [
        "text",
        "body-sm-tight-line"
      ]
    },
    "button-lg-size": {
      "value": "1rem",
      "attributes": {
        "note": "16px",
        "category": "text",
        "type": "button-lg-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "attributes": {
          "note": "16px"
        }
      },
      "name": "TextButtonLgSize",
      "path": [
        "text",
        "button-lg-size"
      ]
    },
    "button-lg-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "button-lg-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextButtonLgLine",
      "path": [
        "text",
        "button-lg-line"
      ]
    },
    "button-md-size": {
      "value": "0.875rem",
      "attributes": {
        "note": "14px",
        "category": "text",
        "type": "button-md-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.875rem",
        "attributes": {
          "note": "14px"
        }
      },
      "name": "TextButtonMdSize",
      "path": [
        "text",
        "button-md-size"
      ]
    },
    "button-md-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "button-md-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextButtonMdLine",
      "path": [
        "text",
        "button-md-line"
      ]
    },
    "button-sm-size": {
      "value": "0.8125rem",
      "attributes": {
        "note": "13px",
        "category": "text",
        "type": "button-sm-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.8125rem",
        "attributes": {
          "note": "13px"
        }
      },
      "name": "TextButtonSmSize",
      "path": [
        "text",
        "button-sm-size"
      ]
    },
    "button-sm-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "button-sm-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextButtonSmLine",
      "path": [
        "text",
        "button-sm-line"
      ]
    },
    "heading-lg-size": {
      "value": "1.5rem",
      "attributes": {
        "note": "24px",
        "category": "text",
        "type": "heading-lg-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1.5rem",
        "attributes": {
          "note": "24px"
        }
      },
      "name": "TextHeadingLgSize",
      "path": [
        "text",
        "heading-lg-size"
      ]
    },
    "heading-lg-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "heading-lg-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextHeadingLgLine",
      "path": [
        "text",
        "heading-lg-line"
      ]
    },
    "heading-md-size": {
      "value": "1.25rem",
      "attributes": {
        "note": "20px",
        "category": "text",
        "type": "heading-md-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1.25rem",
        "attributes": {
          "note": "20px"
        }
      },
      "name": "TextHeadingMdSize",
      "path": [
        "text",
        "heading-md-size"
      ]
    },
    "heading-md-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "heading-md-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextHeadingMdLine",
      "path": [
        "text",
        "heading-md-line"
      ]
    },
    "heading-sm-size": {
      "value": "1.125rem",
      "attributes": {
        "note": "18px",
        "category": "text",
        "type": "heading-sm-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1.125rem",
        "attributes": {
          "note": "18px"
        }
      },
      "name": "TextHeadingSmSize",
      "path": [
        "text",
        "heading-sm-size"
      ]
    },
    "heading-sm-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "heading-sm-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextHeadingSmLine",
      "path": [
        "text",
        "heading-sm-line"
      ]
    },
    "heading-xl-size": {
      "value": "1.75rem",
      "attributes": {
        "note": "28px",
        "category": "text",
        "type": "heading-xl-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1.75rem",
        "attributes": {
          "note": "28px"
        }
      },
      "name": "TextHeadingXlSize",
      "path": [
        "text",
        "heading-xl-size"
      ]
    },
    "heading-xl-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "heading-xl-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextHeadingXlLine",
      "path": [
        "text",
        "heading-xl-line"
      ]
    },
    "heading-xs-size": {
      "value": "1rem",
      "attributes": {
        "note": "16px",
        "category": "text",
        "type": "heading-xs-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "attributes": {
          "note": "16px"
        }
      },
      "name": "TextHeadingXsSize",
      "path": [
        "text",
        "heading-xs-size"
      ]
    },
    "heading-xs-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "heading-xs-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextHeadingXsLine",
      "path": [
        "text",
        "heading-xs-line"
      ]
    },
    "note-lg-size": {
      "value": "0.8125rem",
      "attributes": {
        "note": "13px",
        "category": "text",
        "type": "note-lg-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.8125rem",
        "attributes": {
          "note": "13px"
        }
      },
      "name": "TextNoteLgSize",
      "path": [
        "text",
        "note-lg-size"
      ]
    },
    "note-lg-line": {
      "value": 1.7,
      "attributes": {
        "note": "170%",
        "category": "text",
        "type": "note-lg-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.7,
        "attributes": {
          "note": "170%"
        }
      },
      "name": "TextNoteLgLine",
      "path": [
        "text",
        "note-lg-line"
      ]
    },
    "note-lg-narrow-size": {
      "value": "0.8125rem",
      "attributes": {
        "note": "13px",
        "category": "text",
        "type": "note-lg-narrow-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.8125rem",
        "attributes": {
          "note": "13px"
        }
      },
      "name": "TextNoteLgNarrowSize",
      "path": [
        "text",
        "note-lg-narrow-size"
      ]
    },
    "note-lg-narrow-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "note-lg-narrow-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextNoteLgNarrowLine",
      "path": [
        "text",
        "note-lg-narrow-line"
      ]
    },
    "note-lg-tight-size": {
      "value": "0.8125rem",
      "attributes": {
        "note": "13px",
        "category": "text",
        "type": "note-lg-tight-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.8125rem",
        "attributes": {
          "note": "13px"
        }
      },
      "name": "TextNoteLgTightSize",
      "path": [
        "text",
        "note-lg-tight-size"
      ]
    },
    "note-lg-tight-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "note-lg-tight-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextNoteLgTightLine",
      "path": [
        "text",
        "note-lg-tight-line"
      ]
    },
    "note-md-size": {
      "value": "0.75rem",
      "attributes": {
        "note": "12px",
        "category": "text",
        "type": "note-md-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.75rem",
        "attributes": {
          "note": "12px"
        }
      },
      "name": "TextNoteMdSize",
      "path": [
        "text",
        "note-md-size"
      ]
    },
    "note-md-line": {
      "value": 1.7,
      "attributes": {
        "note": "170%",
        "category": "text",
        "type": "note-md-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.7,
        "attributes": {
          "note": "170%"
        }
      },
      "name": "TextNoteMdLine",
      "path": [
        "text",
        "note-md-line"
      ]
    },
    "note-md-narrow-size": {
      "value": "0.75rem",
      "attributes": {
        "note": "12px",
        "category": "text",
        "type": "note-md-narrow-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.75rem",
        "attributes": {
          "note": "12px"
        }
      },
      "name": "TextNoteMdNarrowSize",
      "path": [
        "text",
        "note-md-narrow-size"
      ]
    },
    "note-md-narrow-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "note-md-narrow-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextNoteMdNarrowLine",
      "path": [
        "text",
        "note-md-narrow-line"
      ]
    },
    "note-md-tight-size": {
      "value": "0.75rem",
      "attributes": {
        "note": "12px",
        "category": "text",
        "type": "note-md-tight-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.75rem",
        "attributes": {
          "note": "12px"
        }
      },
      "name": "TextNoteMdTightSize",
      "path": [
        "text",
        "note-md-tight-size"
      ]
    },
    "note-md-tight-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "note-md-tight-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextNoteMdTightLine",
      "path": [
        "text",
        "note-md-tight-line"
      ]
    },
    "note-sm-size": {
      "value": "0.625rem",
      "attributes": {
        "note": "10px",
        "category": "text",
        "type": "note-sm-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.625rem",
        "attributes": {
          "note": "10px"
        }
      },
      "name": "TextNoteSmSize",
      "path": [
        "text",
        "note-sm-size"
      ]
    },
    "note-sm-line": {
      "value": 1.7,
      "attributes": {
        "note": "170%",
        "category": "text",
        "type": "note-sm-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.7,
        "attributes": {
          "note": "170%"
        }
      },
      "name": "TextNoteSmLine",
      "path": [
        "text",
        "note-sm-line"
      ]
    },
    "note-sm-narrow-size": {
      "value": "0.625rem",
      "attributes": {
        "note": "10px",
        "category": "text",
        "type": "note-sm-narrow-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.625rem",
        "attributes": {
          "note": "10px"
        }
      },
      "name": "TextNoteSmNarrowSize",
      "path": [
        "text",
        "note-sm-narrow-size"
      ]
    },
    "note-sm-narrow-line": {
      "value": 1.5,
      "attributes": {
        "note": "150%",
        "category": "text",
        "type": "note-sm-narrow-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.5,
        "attributes": {
          "note": "150%"
        }
      },
      "name": "TextNoteSmNarrowLine",
      "path": [
        "text",
        "note-sm-narrow-line"
      ]
    },
    "note-sm-tight-size": {
      "value": "0.625rem",
      "attributes": {
        "note": "10px",
        "category": "text",
        "type": "note-sm-tight-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.625rem",
        "attributes": {
          "note": "10px"
        }
      },
      "name": "TextNoteSmTightSize",
      "path": [
        "text",
        "note-sm-tight-size"
      ]
    },
    "note-sm-tight-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "note-sm-tight-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextNoteSmTightLine",
      "path": [
        "text",
        "note-sm-tight-line"
      ]
    },
    "tag-lg-size": {
      "value": "0.8125rem",
      "attributes": {
        "note": "13px",
        "category": "text",
        "type": "tag-lg-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.8125rem",
        "attributes": {
          "note": "13px"
        }
      },
      "name": "TextTagLgSize",
      "path": [
        "text",
        "tag-lg-size"
      ]
    },
    "tag-lg-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "tag-lg-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextTagLgLine",
      "path": [
        "text",
        "tag-lg-line"
      ]
    },
    "tag-md-size": {
      "value": "0.75rem",
      "attributes": {
        "note": "12px",
        "category": "text",
        "type": "tag-md-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.75rem",
        "attributes": {
          "note": "12px"
        }
      },
      "name": "TextTagMdSize",
      "path": [
        "text",
        "tag-md-size"
      ]
    },
    "tag-md-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "tag-md-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextTagMdLine",
      "path": [
        "text",
        "tag-md-line"
      ]
    },
    "tag-sm-size": {
      "value": "0.625rem",
      "attributes": {
        "note": "10px",
        "category": "text",
        "type": "tag-sm-size"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "0.625rem",
        "attributes": {
          "note": "10px"
        }
      },
      "name": "TextTagSmSize",
      "path": [
        "text",
        "tag-sm-size"
      ]
    },
    "tag-sm-line": {
      "value": 1.4,
      "attributes": {
        "note": "140%",
        "category": "text",
        "type": "tag-sm-line"
      },
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": 1.4,
        "attributes": {
          "note": "140%"
        }
      },
      "name": "TextTagSmLine",
      "path": [
        "text",
        "tag-sm-line"
      ]
    },
    "base-family": {
      "value": "UDShinGoPr6N, sans-serif",
      "filePath": "tokens/text/typography.json",
      "isSource": true,
      "original": {
        "value": "UDShinGoPr6N, sans-serif"
      },
      "name": "TextBaseFamily",
      "attributes": {
        "category": "text",
        "type": "base-family"
      },
      "path": [
        "text",
        "base-family"
      ]
    }
  }
};